import { httpLink, loggerLink } from '@trpc/client'
import { createTRPCNext } from '@trpc/next'
import superjson from 'superjson'

import type { AppRouter } from '@rewardops/api'

export const trpcApiForTenant = (host: string) => {
  return createTRPCNext<AppRouter>({
    config() {
      return {
        transformer: superjson,
        abortOnUnmount: true,
        links: [
          loggerLink({
            enabled: (opts) =>
              process.env.NODE_ENV === 'development' ||
              (opts.direction === 'down' && opts.result instanceof Error),
          }),
          httpLink({
            url: `${host}/api/trpc`,
          }),
        ],
      }
    },
    ssr: false,
  })
}

export { type RouterInputs, type RouterOutputs } from '@rewardops/api'
